<template>
  <DetailsContentPane>
    <DetailsSection class="border-bottom-0">
      <RoutePanel @toggle-image-size="handleImageSize" />
    </DetailsSection>
    <DetailsSection 
      type="last"
      class="scrollableContent"
    >
      <RouteTable />
    </DetailsSection>
  </DetailsContentPane>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DetailsContentPane from '../DetailsContentPane.vue';
import DetailsSection from '../DetailsSection.vue';
import RoutePanel from '../overview/RoutePanel.vue';
import RouteTable from './RouteTable.vue';

export default defineComponent({
  components: { DetailsContentPane, DetailsSection, RoutePanel, RouteTable },

  data: () => {
    return {
      max: false,
    }
  },

  methods: {
    handleImageSize(max: boolean) {
      this.max = max
    }
  }
})
</script>

<style lang="scss" scoped>
.scrollableContent {
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
